import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';

export interface SbApiDateTimeDefinition {
  value: DateTime | NgbDateStruct | NgbTimeStruct;
}

export class SbLocalDateTime implements SbApiDateTimeDefinition {
  constructor(value?: DateTime) {
    this.value = value;
  }

  public value: DateTime;
  public encodeMillis: boolean = false;

  static formatMillisInteger(n: number): string {
    return n < 100 ? (n < 10 ? '00' + n : '0' + n) : '' + n;
  }

  public isLocalDateTime(): boolean {
    return true;
  }

  public toString(): string {
    return this.value
      ? this.value.toFormat("yyyy-MM-dd'T'HH:mm:ss") +
          (this.encodeMillis ? '.' + SbLocalDateTime.formatMillisInteger(this.value.millisecond) : '')
      : '';
  }
}

export class SbDateTime implements SbApiDateTimeDefinition {
  public value: DateTime;

  constructor(value?: DateTime) {
    this.value = value;
  }

  public isLocalDateTime(): boolean {
    return false;
  }

  public toString(): string {
    return this.value ? this.value.toISO() : '';
  }
}

export class SbLocalDate implements SbApiDateTimeDefinition {
  constructor(value?: NgbDateStruct) {
    this.value = value;
  }

  public value: NgbDateStruct;

  static formatTimeInteger(n: number): string {
    return (n > 9 ? '' : '0') + n;
  }

  public isLocalDate(): boolean {
    return true;
  }

  public toString(): string {
    let str: string = '';
    if (this.value) {
      str =
        SbLocalDate.formatTimeInteger(this.value.year) +
        '-' +
        SbLocalDate.formatTimeInteger(this.value.month) +
        '-' +
        SbLocalDate.formatTimeInteger(this.value.day);
    }

    return str;
  }
}

export class SbLocalTime implements SbApiDateTimeDefinition {
  constructor(value?: NgbTimeStruct) {
    this.value = value;
  }

  public value: NgbTimeStruct;

  static fromIso(iso: string): SbLocalTime {
    try {
      const ret: SbLocalTime = new SbLocalTime();
      const split: string[] = iso.split(':');
      ret.value = {
        hour: +split[0],
        minute: +split[1],
        second: +split[2].split('.')[0],
      };

      return ret;
    } catch (e) {}
    return null;
  }

  public isSbApiTime(): boolean {
    return true;
  }

  public compareTo(compare: SbLocalTime): number {
    const v1 = this.value;
    const v2 = compare.value;
    if (v1.hour === v2.hour && v1.minute === v2.minute && v1.second === v2.second) {
      return 0;
    }
    if (v1.hour > v2.hour) {
      return 1;
    }
    if (v1.hour < v2.hour) {
      return -1;
    }
    if (v1.minute > v2.minute) {
      return 1;
    }
    if (v1.minute < v2.minute) {
      return -1;
    }
    if (v1.second > v2.second) {
      return 1;
    }
    if (v1.second < v2.second) {
      return -1;
    }
  }

  public toString(): string {
    let str: string = '';
    if (this.value) {
      str =
        this.formatTimeInteger(this.timePartZeroDefault(this.value.hour)) +
        ':' +
        this.formatTimeInteger(this.timePartZeroDefault(this.value.minute)) +
        ':' +
        this.formatTimeInteger(this.timePartZeroDefault(this.value.second)) +
        '.' +
        '000';
    }

    return str;
  }

  public toHumanString(): string {
    let str: string = '';
    if (this.value) {
      str =
        this.formatTimeInteger(this.timePartZeroDefault(this.value.hour)) +
        ':' +
        this.formatTimeInteger(this.timePartZeroDefault(this.value.minute)) +
        ':' +
        this.formatTimeInteger(this.timePartZeroDefault(this.value.second));
    }

    return str;
  }

  formatTimeInteger(n: number): string {
    return (n > 9 ? '' : '0') + n;
  }

  timePartZeroDefault(n?: number): number {
    if (n) {
      return n;
    }
    return 0;
  }
}
